export const MUI_TABLE_OPTIONS = {
  filter: false,
  print: false,
  viewColumns: false,
  selectableRows: 'none',
  search: true,
  elevation: false,
  download: true,
  rowsPerPage: 10,
};

export const CHARTS_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  stroke: {
    curve: 'smooth',
  },

  // interaction: {
  //   intersect: false,
  // },
  tooltips: {
    mode: 'x-axis',
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      mode: 'index',
      intersect: false,
    },
  },
  hover: {
    mode: 'nearest',
    intersect: false,
  },

  scales: {
    x: {
      display: true,
      grid: {
        display: false,
      },
      ticks: {
        display: true, // this will remove only the label
      },
    },
    y: {
      decimalsInFloat: 0,

      display: true,
      grid: {
        display: true,
      },
      ticks: {
        display: true, // this will remove only the label
      },
      zeroLineColor: 'transparent',
    },
  },
  legend: {
    display: true,
  },
};

export const AISLE_TYPE = {
  BRANDED_KEYWORDS: 'ownBrandedKeywords',
  HERO_KEYWORD: 'otherKeywords',
};

export const AISLE_ACTIVE_STATUS = ['active', 'initializing', 'pending'];

export const ORGANIZATION_TYPE = {
  BRAND: 'BRAND',
  AGENCY: 'AGENCY',
  WHITE_LABELED: 'WHITE_LABELED',
};

export const CAMPAIGN_TYPE = {
  SB: 'sponsoredBrands',
  SD: 'sponsoredDisplay',
  SP: 'sponsoredProducts',
};

export const SP_PLACEMENT_ADJUSTMENT = {
  PLACEMENT_TOP: 'PLACEMENT_TOP',
  PLACEMENT_PRODUCT_PAGE: 'PLACEMENT_PRODUCT_PAGE',
  PLACEMENT_REST_OF_SEARCH: 'PLACEMENT_REST_OF_SEARCH',
};

export const SP_CAMPAIGN_BIDDING_STRATEGY = {
  LEGACY_FOR_SALES: 'LEGACY_FOR_SALES',
  AUTO_FOR_SALES: 'AUTO_FOR_SALES',
  MANUAL: 'MANUAL',
  RULE_BASED: 'RULE_BASED',
};

export const SP_CAMPAIGN_BIDDING_STRATEGY_TEXT = {
  LEGACY_FOR_SALES: 'Dynamic bids - down only',
  AUTO_FOR_SALES: 'Dynamic bids - up and down',
  MANUAL: 'Fixed bid',
  // RULE_BASED: 'Rule based bidding',
};
